import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { SNS_LINKS } from '../../../domain/consultation-counter/constants';
import * as styles from './FooterSocialSection.module.css';

const FooterSocialSection: React.FC = () => {
  return (
    <div className={styles.socialSection}>
      <div className={styles.socialLinks} aria-label='ソーシャルメディアリンク'>
        <a
          href={SNS_LINKS.instagram}
          target='_blank'
          rel='noopener noreferrer'
          className={styles.socialLink}
          aria-label='Instagramを開く（新しいタブ）'
        >
          <StaticImage
            src='../../../../static/img/instagram.png'
            alt='Instagram'
            className={styles.socialIcon}
            placeholder="blurred"
          />
        </a>
        <a
          href={SNS_LINKS.youtube}
          target='_blank'
          rel='noopener noreferrer'
          className={styles.socialLink}
          aria-label='YouTubeを開く（新しいタブ）'
        >
          <StaticImage
            src='../../../../static/img/youtube.png'
            alt='YouTube'
            className={styles.socialIcon}
            placeholder="blurred"
          />
        </a>
      </div>
    </div>
  );
};

export default FooterSocialSection;
